/****   request.js   ****/
// 导入axios
import axios from 'axios'
import Cookies from 'js-cookie'  //要注意同IP ，不同端口号的cookie会共享
import _this from '../main.js'
// 使用element-ui Message做消息提醒
import { Message} from 'element-ui';
import _store from '../../store/store.js'
//1. 创建新的axios实例，
console.log(process.env.NODE_ENV)
let baseURL = ''
// if(process.env.NODE_ENV === 'development') {
  // 开发环境相关特殊方法
  baseURL = 'https://su.ljszh.test.rootcloudapp.com/'
  // baseURL = 'http://10.8.218.47:31003'  //黄华军
  // baseURL = 'http://10.8.206.199:31003' //郭海良
  // baseURL = 'http://10.8.220.143:31003' //张彪
  // baseURL = 'http://10.0.14.247:8017' //测试
// }
if(window.location.href.indexOf('10.0.14.247') > 0) {
  // 测试环境相关特殊方法
  baseURL = 'http://10.0.14.247:8019'
}
if(window.location.href.indexOf('ljszh.sany.com.cn') > 0) {
  // 生产环境相关特殊方法
  baseURL = 'http://62.234.160.39:8018'
  // baseURL = 'http://10.0.14.247:8017'
}
if(window.location.href.indexOf('su.ljszh.test.rootcloudapp.com/') > 0) {
  // 新路机测试环境
  baseURL = 'https://su.ljszh.test.rootcloudapp.com/'
}
// let baseURL = 'http://ljszh.sany.com.cn'
// let baseURL = 'http://10.0.14.247:8017'
// let baseURL = 'http://localhost:8017'
// let baseURL = 'http://127.0.0.1:8017'
// let baseURL = 'http://62.234.160.39:8017'
// let baseURL = 'http://10.8.211.201:8017'
// let baseURL = 'http://10.0.12.136:9430'
// let baseURL = 'http://10.8.218.47:31003' // 黄华军 
// let baseURL = 'http://10.8.206.199:31003' // 郭海良
// let baseURL = 'http://10.8.206.199:36002' // 郭海良110.8.211.201:8080
// let baseURL = 'http://10.8.211.201:36002'
// let baseURL = 'http://10.8.211.201:8017'
// let baseURL = 'http://10.8.211.201:9430'
// let baseURL = 'http://10.0.12.136:31015'
// let baseURL = window.location.href
console.log(baseURL)
const service = axios.create({
  // 公共接口--这里注意后面会讲
  baseURL: baseURL,
  // 超时时间 单位是ms，这里设置了3s的超时时间
  timeout: 200 * 1000
})

// 2.请求拦截器
service.interceptors.request.use(config => {
    // console.log(config)
    //发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等，根据需求去添加
    config.data = JSON.stringify(config.data); //数据转化,也可以使用qs转换
    // console.log(config)
    if(config.method == 'post'){
        if(config.type=='postpdf'){
          config.headers = {
            'Content-Type':'multipart/form-data' //配置请求头
          }
        }
        else if(config.type=="postFile"){
          config.headers = {
            'Content-Type':'multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW'
          }
        }else{
          config.headers = {
            'Content-Type':'application/json;charset=UTF-8' //配置请求头
          }
        }
        config.headers.Accept = 'application/json, text/plain, */*'
        
    }else if(config.method == 'put'){ 
        config.data = JSON.parse(JSON.stringify(config.params))
    }else if(config.type == 'new'){
          config.data = JSON.parse(JSON.stringify(config.params))
          config.headers = {
            'Content-Type':'application/json;charset=UTF-8' //配置请求头
          }
          config.headers.Accept = 'application/json, text/plain, */*'
    }else{
        config.headers = {
            'Content-Type':'application/x-www-form-urlencoded' //配置请求头
        }
    }
    //console.log(config)
   //注意使用token的时候需要引入cookie方法或者用本地localStorage等方法，推荐js-cookie
   const token = Cookies.get('token');//这里取token之前，你肯定需要先拿到token,存一下
   if(token){
      // config.params = {'token':token} //如果要求携带在参数中
      config.headers.token= token; //如果要求携带在请求头中
    }
    config.headers.token = token
    config.headers.Authorization = token
  return config
}, error => {
  Promise.reject(error)
})

// 3.响应拦截器
service.interceptors.response.use(response => {
  //接收到响应数据并成功后的一些共有的处理，关闭loading等
  // console.log(response.data,'code')
  let getCode = response.data.code
  // if(getCode == 401){
  //   Message.error('登录过期' )
  //   console.log(_this)
  //   _this.$router.push('/');
  // }
  if(getCode == 401){
    if(_store.state.isOverLogin==false){
      Message.error(response.data.message)
      _this.$router.push('/');
      _store.commit("setOverLogin", true);
      setTimeout(()=>{
        _store.commit("setOverLogin", false);
      },5000)
    }
  }
  // console.log(response)
  if(response.data.code != 200 && response.data.code != 401){
    if(response.data.code){
      Message.error(response.data.message)
    }else{
      console.log('')
    }
  }
  if(response.config){
    if(response.config.responseType=='blob' || response.config.responseType=='arraybuffer'){
      if(response.data.byteLength < 80 || response.data.size < 80){
        Message.error('下载失败' )
        return
      }else{
        Message.success('下载成功' )
      }
    }
  }
  return response
}, error => {
  // console.log(error)
   /***** 接收到异常响应的处理开始 *****/
  if (error && error.response) {
    // 1.公共错误处理
    // 2.根据响应码具体处理
    switch (error.response.code) {
      case 400:
        error.message = '错误请求'
        break;
      case 401:
        error.message = '未授权，请重新登录'
        break;
      case 403:
        error.message = '拒绝访问'
        break;
      case 404:
        error.message = '请求错误,未找到该资源'
        window.location.href = "/NotFound"
        break;
      case 405:
        error.message = '请求方法未允许'
        break;
      case 408:
        error.message = '请求超时'
        break;
      case 500:
        error.message = '服务器端出错'
        break;
      case 501:
        error.message = '网络未实现'
        break;
      case 502:
        error.message = '网络错误'
        break;
      case 503:
        error.message = '服务不可用'
        break;
      case 504:
        error.message = '网络超时'
        break;
      case 505:
        error.message = 'http版本不支持该请求'
        break;
      default:
        error.message = `连接错误${error.response.status}`
    }
  } else {
    // 超时处理
    if (JSON.stringify(error).includes('timeout')) {
      Message.error('服务器响应超时，请刷新当前页')
    }
    error.message('连接服务器失败')
  }

  Message.error(error.message)
  /***** 处理结束 *****/
  //如果不需要错误处理，以上的处理过程都可省略
  return Promise.resolve(error.response)
})
//4.导入文件
export default service